import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './view.scss';

function initCarousels() {
	// :not selector prevents double-init if called multiple times.
	document.querySelectorAll( '.gc-carousel-swiper:not([data-swiper-initialized])' ).forEach( ( el ) => {
		el.dataset.swiperInitialized = 'true';

		const raw = el.dataset.swiperConfig;
		if ( ! raw ) return;

		let cfg;
		try {
			cfg = JSON.parse( raw );
		} catch ( e ) {
			// eslint-disable-next-line no-console
			console.error( 'GC Carousel: invalid config JSON', e );
			return;
		}

		const modules = [ A11y ];
		if ( cfg.navigation ) modules.push( Navigation );
		if ( cfg.pagination ) modules.push( Pagination );
		if ( cfg.autoplay )   modules.push( Autoplay );

		new Swiper( el, {
			modules,
			slidesPerView:  cfg.slidesPerView  ?? 1,
			slidesPerGroup: cfg.slidesPerGroup  ?? 1,
			spaceBetween:   cfg.spaceBetween    ?? 0,
			speed:          cfg.speed           ?? 500,
			loop:           cfg.loop            ?? false,
			navigation: cfg.navigation ? {
				nextEl: el.querySelector( '.swiper-button-next' ),
				prevEl: el.querySelector( '.swiper-button-prev' ),
			} : false,
			pagination: cfg.pagination ? {
				el:        el.querySelector( '.swiper-pagination' ),
				clickable: true,
			} : false,
			autoplay: cfg.autoplay ? {
				delay:                cfg.autoplayDelay     ?? 3000,
				pauseOnMouseEnter:    cfg.pauseOnMouseEnter ?? false,
				disableOnInteraction: false,
			} : false,
			breakpoints: cfg.breakpoints ?? {},
			dir:  cfg.rtl ? 'rtl' : 'ltr',
			a11y: { enabled: true },
		} );

		if ( cfg.gallery ) {
			el.classList.add( 'gc-gallery-mode' );

			const modalEl = document.getElementById( `${ el.id }-modal` );
			if ( modalEl && window.bootstrap && window.bootstrap.Modal ) {
				const modalImg = modalEl.querySelector( '.gc-lightbox-img' );

				el.querySelectorAll( '.gc-slide-img' ).forEach( ( img ) => {
					img.addEventListener( 'click', () => {
						modalImg.src = img.currentSrc || img.src;
						modalImg.alt = img.alt;
						window.bootstrap.Modal.getOrCreateInstance( modalEl ).show();
					} );
				} );
			}
		}
	} );
}

// Call immediately — carousel markup is already in the DOM when this
// footer script executes. DOMContentLoaded is a safety net for edge cases
// (e.g. defer attribute applied by WordPress).
initCarousels();
document.addEventListener( 'DOMContentLoaded', initCarousels );
